<template>
  <div class="page-container profile-page">
    <el-card v-loading="loading" class="profile-card" shadow="never">
      <div class="profile-head">
        <el-avatar :size="72" :src="avatarSrc" class="profile-avatar">
          {{ avatarFallback }}
        </el-avatar>
        <div class="profile-name">{{ displayName }}</div>
        <div class="profile-company" v-if="companyName">{{ companyName }}</div>
        <el-tag size="small" effect="plain" class="profile-role">{{ userRole }}</el-tag>
      </div>

      <div class="profile-divider" />

      <div class="profile-items">
        <div class="profile-item">
          <span class="item-label">账号</span>
          <span class="item-value">{{ accountName }}</span>
        </div>
        <div class="profile-item">
          <span class="item-label">姓名</span>
          <span class="item-value">{{ personName || '—' }}</span>
        </div>
        <div class="profile-item">
          <span class="item-label">手机号</span>
          <span class="item-value">{{ phone || '—' }}</span>
        </div>
        <div class="profile-item">
          <span class="item-label">性别</span>
          <span class="item-value">{{ genderText }}</span>
        </div>
        <div class="profile-item">
          <span class="item-label">所属公司</span>
          <span class="item-value">{{ companyName || '—' }}</span>
        </div>
        <div class="profile-item">
          <span class="item-label">角色</span>
          <span class="item-value">{{ userRole }}</span>
        </div>
      </div>

      <div class="profile-actions">
        <el-button type="primary" icon="el-icon-lock" size="small" @click="goChangePassword">修改密码</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
// 个人中心（顶栏头像下拉入口，不进侧边栏菜单）
// 资料取 GET /mine/info（账号 / 姓名 / 手机号 / 性别 / 头像）；
// 所属公司与角色登录时已下发、直接用登录态，不再多查一次接口。
// 编辑资料（PUT /mine/info）后端未开发，暂不提供。
import { getProfile } from '@/api/mine'

export default {
  name: 'MineProfile',
  data() {
    return {
      loading: false,
      profile: {
        username: '',
        person_name: '',
        phone: '',
        avatar: '',
        gender: ''
      }
    }
  },
  computed: {
    // 登录态里的账号/头像/公司/角色
    userName() { return this.$store.getters.getUserName || '管理员' },
    userAvatar() { return this.$store.getters.getUserAvatar || '' },
    companyName() { return this.$store.getters.getCompanyName || '' },
    userRole() { return this.$store.getters.getUserRole || '管理员' },
    // 接口回来的资料优先，没取到退登录态
    accountName() { return this.profile.username || this.userName },
    personName() { return this.profile.person_name || '' },
    avatarSrc() { return this.profile.avatar || this.userAvatar },
    phone() { return this.profile.phone || '' },
    gender() {
      return this.profile.gender === '' || this.profile.gender === null
        ? this.$store.getters.getUserGender
        : this.profile.gender
    },
    genderText() {
      if (Number(this.gender) === 0) return '男'
      if (Number(this.gender) === 1) return '女'
      return '未填写'
    },
    // 姓名优先，没姓名用账号；头像缺失时显示首字
    displayName() { return this.personName || this.accountName },
    avatarFallback() {
      return (this.displayName || '管').slice(0, 1)
    }
  },
  created() {
    this.loadProfile()
  },
  methods: {
    loadProfile() {
      this.loading = true
      getProfile().then(res => {
        if (res.code !== 200) return
        const data = res.data || {}
        this.profile = {
          username: data.username || '',
          person_name: data.person_name || '',
          phone: data.phone || '',
          avatar: data.avatar || '',
          gender: data.gender === null || data.gender === undefined ? '' : data.gender
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    },
    goChangePassword() {
      this.$router.push('/mine/password')
    }
  }
}
</script>

<style scoped>
.profile-page {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
}
.profile-card {
  width: 480px;
  align-self: flex-start;
  border-radius: 10px;
}
.profile-head {
  text-align: center;
  padding: 18px 0 6px;
}
.profile-avatar {
  background-color: rgba(142, 17, 3, 0.08);
  color: var(--primary);
  font-size: 26px;
}
.profile-name {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-100, #303133);
}
.profile-company {
  margin-top: 4px;
  font-size: 13px;
  color: #909399;
}
.profile-role {
  margin-top: 10px;
}
.profile-divider {
  height: 1px;
  background-color: var(--border, #ebeef5);
  margin: 18px 0;
}
.profile-items {
  padding: 0 12px;
}
.profile-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
}
.profile-item + .profile-item {
  border-top: 1px dashed var(--border-light, #f0f0f0);
}
.item-label {
  width: 90px;
  color: #909399;
  flex: 0 0 auto;
}
.item-value {
  color: var(--text-100, #303133);
}
.profile-actions {
  margin-top: 22px;
  text-align: center;
  padding-bottom: 6px;
}
</style>
